import { Home, BookOpen, ShoppingBag, LayoutGrid } from "lucide-react"
import { Link, useLocation } from "react-router-dom"

export function BottomNav() {
  const location = useLocation()
  
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t px-6 py-2 flex justify-between items-center safe-area-inset-bottom max-w-[480px] mx-auto">
      <NavItem icon={Home} label="Beranda" href="/" active={location.pathname === '/'} />
      <NavItem icon={BookOpen} label="Panduan" href="/panduan" active={location.pathname.startsWith('/panduan')} />
      <NavItem icon={ShoppingBag} label="Etalase" href="/etalase" active={location.pathname.startsWith('/etalase')} />
      <NavItem icon={LayoutGrid} label="About" href="/menu" active={location.pathname.startsWith('/menu')} />
    </nav>
  )
}

function NavItem({
  icon: Icon,
  label,
  href,
  active = false,
}: {
  icon: any
  label: string
  href: string
  active?: boolean
}) {
  return (
    <Link
      to={href}
      className={`flex flex-col items-center gap-1 transition-colors active:opacity-70 ${
        active ? "text-primary" : "text-muted-foreground"
      }`}
    >
      <Icon size={24} strokeWidth={active ? 2.5 : 2} />
      <span className="text-[10px] font-bold uppercase tracking-wider">{label}</span>
    </Link>
  )
}






